function handleTextButtonClick() {
  const phoneNumber = '+918879412354'; // Replace with the actual phone number in international format
  const message = encodeURIComponent('Hello, I’d like to schedule a video call to see more details about this pendant/bracelet. Could you let me know the available times for a live demonstration?'); // Customize your message
  const whatsappLink = `https://wa.me/${phoneNumber}?text=${message}`;

  window.location.href = whatsappLink;
}
